import React from 'react'
import { Container } from 'react-bootstrap'
import imageUrl from '../../images/about-us.webp'
import SectionHeader from '../../components/SectionHeader'

const About = () => {
    return (
        <>
            <section>
                <SectionHeader title='about us' PageLink='about us'></SectionHeader>
                <div className="in-page-container pt-5 pb-5">
                    <div className="about-section top__about">
                        <Container>
                            <div className='inner__about'>
                                <div className="about-img img-holder float_about-img">
                                    <img src={imageUrl} alt="about us" />
                                </div>
                                <div>
                                    <div class="about-text">
                                        <h2>About All Events Insure</h2>
                                        <p>
                                            Your dedicated partner in providing comprehensive event insurance solutions tailored to your needs.
                                            <br />
                                            <br />
                                            <h2>Who We Are</h2>
                                            <br />
                                            Welcome to All Events Insure, your dedicated partner in comprehensive event insurance solutions. At All Events Insure, we specialise in providing tailored insurance coverage to ensure your events are protected from unexpected challenges. Our team of experienced professionals is passionate about delivering reliable and customized insurance solutions, allowing you to focus on making your event a success.
                                            <br />
                                            <br />
                                            <br />
                                            With a deep understanding of the unique risks associated with various types of events, we offer a range of insurance products designed to cover everything from large-scale corporate gatherings to intimate private parties. Our commitment is to offer exceptional service and support, ensuring peace of mind for event organisers and participants alike.
                                            <br />
                                            <br />
                                            <h2>What We Do</h2>
                                            <br />
                                            At All Events Insure, we provide a comprehensive suite of event insurance options designed to safeguard your event from potential risks and liabilities. Whether you’re planning a wedding, conference, festival, or any other type of event, we’ve got you covered. Here’s what we offer:
                                            <br />
                                            <br />
                                            <ul>
                                                <li>
                                                    <strong>Liability Insurance: </strong>
                                                    Coverage for accidental damages or injuries that may occur during your event.
                                                </li>
                                                <li>
                                                    <strong>Property Insurance: </strong>
                                                    Safeguard your rented or owned equipment and property from damage or theft.
                                                </li>
                                                <li>
                                                    <strong>Weather Insurance: </strong>
                                                    Coverage for weather-related disruptions that could impact your event.
                                                </li>
                                                <li>
                                                    <strong>Specialized Coverage: </strong>
                                                    Tailored insurance solutions for unique or high-risk events.
                                                </li>
                                            </ul>
                                            <br />
                                            Our user-friendly application process, competitive rates, and responsive customer support make securing event insurance straightforward and hassle-free. At All Events Insure, we are dedicated to ensuring that every detail of your event is protected, so you can concentrate on delivering an unforgettable experience.
                                            <br />
                                            <br />
                                            Explore our website to learn more about our services and how we can help make your next event seamless and secure
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About